import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

type LeadAfterRegistrationEventAction = "view" | "click" | "close";

export const gtmLeadAfterRegistration = (action: LeadAfterRegistrationEventAction, category: string, label?: string) => {
    hitGoogleTagManager({
        event: "modal_post_price_reveal",
        event_action: action,
        event_category: category,
        ...(label ? {event_label: label} : {})
    });
};
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

type LeadAfterRegistrationEventAction = "view" | "click" | "close";

export const gtmLeadAfterRegistration = (action: LeadAfterRegistrationEventAction, category: string, label?: string) => {
    hitGoogleTagManager({
        event: "modal_post_price_reveal",
        event_action: action,
        event_category: category,
        ...(label ? {event_label: label} : {})
    });
};
